import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { FrontClearanceFilterEnum } from "../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.frontClearanceState
    ? { ...initialState, ...state.frontClearanceState }
    : initialState;

export const selectFrontClearanceManufacturerFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.manufacturerFilter
);

export const selectFrontClearanceMasterModelFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.masterModelFilter
);

export const selectFrontClearanceYearFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.yearFilter
);

export const selectFrontClearanceLoading = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.loading
);

export const selectFrontClearanceList = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.list
);

export const selectFrontClearanceMeta = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.meta
);

export const selectFrontClearancePage = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.page
);

export const selectFrontClearancePerPage = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.isAddModalOpen
);

export const selectFrontClearanceForm = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.form
);

export const selectFrontClearanceFormDropDowns = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.formDropDowns,
);

export const selectFrontClearanceSaving = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.saving
);

export const selectFrontClearanceFilterOptions = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.filterOptions
);

export const selectFrontClearanceManufacturerOptions = createSelector(
  [selectFrontClearanceFilterOptions],
  (filterOptions) =>
    filterOptions[FrontClearanceFilterEnum.Manufacturers] ?? [],
);

export const selectFrontClearanceModelOptions = createSelector(
  [selectFrontClearanceFilterOptions],
  (filterOptions) => filterOptions[FrontClearanceFilterEnum.Models] ?? [],
);

export const selectFrontClearanceSuperModelOptions = createSelector(
  [selectFrontClearanceFilterOptions],
  (filterOptions) => filterOptions[FrontClearanceFilterEnum.SuperModels] ?? [],
);

export const selectFrontClearanceYearOptions = createSelector(
  [selectFrontClearanceFilterOptions],
  (filterOptions) => filterOptions[FrontClearanceFilterEnum.Years] ?? [],
);

export const selectFrontClearanceFilterOptionsLoading = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.filterOptionsLoading
);

export const selectFrontClearanceFilterOptionsError = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.filterOptionsError
);

export const selectFilteredFrontClearanceList = createSelector(
  [selectDomain],
  ({ list, manufacturerFilter, masterModelFilter }) => {
    let filtered = list;
    if (manufacturerFilter !== "ALL") {
      filtered = filtered.filter(
        (row) => String(row.manufacturerId) === manufacturerFilter,
      );
    }
    if (masterModelFilter !== "ALL") {
      filtered = filtered.filter(
        (row) => String(row.superModelId) === masterModelFilter,
      );
    }
    return filtered;
  },
);
